import i18n from '../i18n';

// An ISO 8601 duration as a backend writes it into a message: PT24H, P3D,
// PT1H30M. Week and year/month forms do not appear in our messages.
const ISO_DURATION = /\bP(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?\b/g;

// Literal keys, so the translation check sees each one.
const UNITS = [
    (count) => i18n.t('durations.days', { count }),
    (count) => i18n.t('durations.hours', { count }),
    (count) => i18n.t('durations.minutes', { count }),
    (count) => i18n.t('durations.seconds', { count })
];

/**
 * Spells out the ISO durations in a backend message — "not paid within PT24H"
 * becomes "not paid within 24 hours" — and leaves everything else as it is.
 */
export const humanizeIsoDurations = (text) => {
    if (typeof text !== 'string' || !text.includes('P')) return text;
    return text.replace(ISO_DURATION, (match, ...parts) => {
        const spelled = parts
            .slice(0, 4)
            .map((count, unit) => (count ? UNITS[unit](Number(count)) : null))
            .filter(Boolean);
        // A bare "P" or "PT" is a word, not a duration.
        return spelled.length ? spelled.join(' ') : match;
    });
};
